import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeComponentLottieFields {
  internalName: EntryFieldTypes.Symbol
  autoplayType: EntryFieldTypes.Symbol<'Click' | 'Hover' | 'Loop' | 'Visible'>
  lottieFile: EntryFieldTypes.AssetLink
  mobileLottieFile?: EntryFieldTypes.AssetLink
  metadata?: EntryFieldTypes.Object
}

export type TypeComponentLottieSkeleton = EntrySkeletonType<TypeComponentLottieFields, 'componentLottie'>
export type TypeComponentLottie<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentLottieSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentLottie<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentLottie<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentLottie'
}
